import {
  dripMediumOrder,
  getDripMediumDescription,
  getDripMediumIcon,
  getDripMediumName
} from 'features/CustomCampaigns/EditCampaign/dripMediumMeta'

import styles from './ChannelStrategyStep.module.scss'

function ChannelStrategyStep({ medium, setMedium, isEditable = true }) {
  const SelectedIcon = medium ? getDripMediumIcon(medium) : null

  return (
    <div className={styles.step}>
      <div className={styles.optionsPanel}>
        <h2 className={styles.optionsTitle}>Select channel strategy</h2>
        <p className={styles.optionsIntro}>
          Choose how this campaign will be delivered and preview each experience.
        </p>
        <div
          className={styles.optionList}
          role="radiogroup"
          aria-label="Channel strategy"
        >
          {dripMediumOrder.map(option => {
            const OptionIcon = getDripMediumIcon(option)
            const isSelected = medium === option

            return (
              <button
                key={option}
                type="button"
                role="radio"
                aria-checked={isSelected}
                disabled={!isEditable}
                onClick={() => setMedium(option)}
                className={isSelected ? styles.optionCardSelected : styles.optionCard}
              >
                <span className={styles.optionHeader}>
                  <OptionIcon className={styles.optionIcon} />
                  <span className={styles.optionName}>{getDripMediumName(option)}</span>
                  <span className={styles.optionRadio} aria-hidden="true" />
                </span>
                <span className={styles.optionDescription}>
                  {getDripMediumDescription(option)}
                </span>
              </button>
            )
          })}
        </div>
      </div>
      <div className={styles.previewPanel}>
        {medium ? (
          <div className={styles.previewCard}>
            <span className={styles.previewChannelBadge} aria-hidden="true">
              <SelectedIcon />
            </span>
            <span className={styles.previewIcon} aria-hidden="true">
              <SelectedIcon />
            </span>
            <strong className={styles.previewTitle}>Initial Message</strong>
            <span className={styles.previewDescription}>
              The first message sent when your campaign begins.
            </span>
          </div>
        ) : (
          <div className={styles.previewEmpty}>
            <span className={styles.previewEmptyIcon} aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                <path
                  d="M9.333 1.333H4a1.333 1.333 0 0 0-1.333 1.334v10.666A1.333 1.333 0 0 0 4 14.667h8a1.333 1.333 0 0 0 1.333-1.334V5.333l-4-4Z"
                  stroke="currentColor"
                  strokeWidth="1.2"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.333 1.333v4h4"
                  stroke="currentColor"
                  strokeWidth="1.2"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <strong className={styles.previewEmptyTitle}>
              Please select a channel strategy
            </strong>
            <span className={styles.previewEmptyDescription}>
              Choose Text only, Email only, or a combined strategy on the left
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default ChannelStrategyStep
